// extracted by mini-css-extract-plugin
export default {"createworkflowtab":"MenuTabs_createworkflowtab__oqSu1","selected":"MenuTabs_selected__3T42W","createworkflowtabcontents":"MenuTabs_createworkflowtabcontents__T+zqz"};